import { NodeContext } from "../../base";
import { IsPlatformNode } from "./IsPlatformNode";

export class IsVRNode extends IsPlatformNode {
  static readonly type = "action/isVR";
  static readonly label = "Is VR";

  constructor(context: NodeContext) {
    super(context, (device) => device === "vr");
  }
}
